export default __webpack_public_path__ + "static/media/icon-pnc-logo-text.ba46bcf0.svg";